import { capitalize } from './strings';
export function stringifyAddress(address) {
  var streetAddress = address.street_address,
    locality = address.locality,
    administrativeAreaLevel1 = address.administrative_area_level_1,
    postalCode = address.postal_code;
  var addressStr = '';
  if (streetAddress) {
    addressStr = "".concat(capitalize(streetAddress), " ").concat(capitalize(locality), ", ").concat(capitalize(administrativeAreaLevel1));
  } else {
    addressStr = "".concat(capitalize(locality), ", ").concat(capitalize(administrativeAreaLevel1));
  }
  if (postalCode) {
    addressStr = "".concat(addressStr, " ").concat(postalCode);
  }
  return addressStr;
}
export function stringifyAddresses(addresses) {
  return addresses.map(stringifyAddress);
}